import { render, staticRenderFns } from "./MessageDetailItemWrapper.vue?vue&type=template&id=19afcb9c&scoped=true"
import script from "./MessageDetailItemWrapper.vue?vue&type=script&lang=ts"
export * from "./MessageDetailItemWrapper.vue?vue&type=script&lang=ts"
import style0 from "./MessageDetailItemWrapper.vue?vue&type=style&index=0&id=19afcb9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19afcb9c",
  null
  
)

export default component.exports